<script>
import liffService from "@/services/liff";
import {
  finishTapCoinRound,
  getTapCoinStatus,
  startTapCoinRound
} from "@/services/tapCoinGame";
import TapCoinReactor from "@/components/tap-coin/TapCoinReactor.vue";
import TapCoinResult from "@/components/tap-coin/TapCoinResult.vue";

const DEFAULT_DURATION_MS = 10000;
const DEFAULT_COUNTDOWN_MS = 3000;

export default {
  name: "TapCoinGame",
  components: {
    TapCoinReactor,
    TapCoinResult
  },
  data() {
    return {
      state: "loading",
      accessToken: "",
      balance: 0,
      totalDeposit: 0,
      minDeposit: 350,
      reward: 0,
      tapCount: 0,
      tapOffsetsMs: [],
      submittedOffsetsMs: [],
      roundToken: "",
      durationMs: DEFAULT_DURATION_MS,
      remainingMs: DEFAULT_DURATION_MS,
      countdown: 0,
      roundReady: false,
      countdownFinished: false,
      playStartedAt: 0,
      countdownStartedAt: 0,
      countdownDurationMs: DEFAULT_COUNTDOWN_MS,
      countdownTimer: null,
      countdownEndTimer: null,
      gameTimer: null,
      gameEndTimer: null,
      roundEnding: false,
      destroyed: false,
      detailMessage: ""
    };
  },
  computed: {
    profile() {
      return liffService.profile || {};
    },
    displayName() {
      return this.profile.displayName || "สมาชิก UFAEASY888";
    },
    avatarStyle() {
      return this.profile.pictureUrl
        ? { backgroundImage: `url(${this.profile.pictureUrl})` }
        : {};
    },
    formattedBalance() {
      return Number(this.balance || 0).toLocaleString();
    },
    formattedTotalDeposit() {
      return Number(this.totalDeposit || 0).toLocaleString();
    },
    formattedMinDeposit() {
      return Number(this.minDeposit || 350).toLocaleString();
    },
    showGamePanel() {
      return [
        "ready",
        "starting",
        "countdown",
        "playing",
        "submitting"
      ].includes(this.state);
    },
    reactorActive() {
      return this.state === "playing";
    },
    isSubmitting() {
      return this.state === "submitting";
    },
    isWaitingForRound() {
      return (
        this.state === "countdown" && this.countdownFinished && !this.roundReady
      );
    },
    gameStatusText() {
      if (this.state === "starting") return "กำลังล็อกสิทธิ์การเล่น...";
      if (this.state === "countdown")
        return this.isWaitingForRound
          ? "กำลังยืนยันสิทธิ์ อีกนิดเดียว..."
          : "เตรียมนิ้วให้พร้อม!";
      if (this.state === "playing")
        return "แตะรัวเลย! ทุก TAP เพิ่ม 0.5 เหรียญ";
      if (this.state === "submitting") return "กำลังตรวจสอบและเพิ่มเหรียญ...";
      return "มีสิทธิ์เล่นเพียง 1 ครั้ง กดเริ่มแล้วห้าม refresh";
    },
    terminalCopy() {
      const copies = {
        result: {
          variant: "success",
          title: "รับเหรียญสำเร็จ!",
          message: "ระบบตรวจสอบจำนวน tap และเพิ่มเหรียญเข้าบัญชีเรียบร้อยแล้ว",
          showReward: true,
          canRetry: false,
          retryLabel: ""
        },
        "already-used": {
          variant: "warning",
          title: "ใช้สิทธิ์แล้ว",
          message:
            this.detailMessage ||
            "LINE user นี้เริ่มหรือเล่นกิจกรรมไปแล้ว ไม่สามารถเริ่มรอบใหม่ได้",
          showReward: false,
          canRetry: false,
          retryLabel: ""
        },
        "event-upcoming": {
          variant: "info",
          title: "กิจกรรมยังไม่เริ่ม",
          message:
            "กลับมาเล่นได้วันที่ 12 สิงหาคม 2026 เวลา 18:00 น. ตามเวลาไทย และต้องมียอดฝากสำเร็จช่วง 18:00–23:59 น. รวมอย่างน้อย 350 บาท",
          showReward: false,
          canRetry: true,
          retryLabel: "ตรวจสอบอีกครั้ง"
        },
        "deposit-insufficient": {
          variant: "warning",
          title: "ยอดฝากยังไม่ถึงเกณฑ์",
          message: `ต้องมียอดฝากสำเร็จวันที่ 12 สิงหาคม ช่วง 18:00–23:59 น. รวมอย่างน้อย ${this.formattedMinDeposit} บาท ตอนนี้มียอดรวม ${this.formattedTotalDeposit} บาท`,
          showReward: false,
          canRetry: true,
          retryLabel: "ตรวจสอบยอดฝากอีกครั้ง"
        },
        "event-closed": {
          variant: "warning",
          title: "กิจกรรมสิ้นสุดแล้ว",
          message:
            "Tap Coin Reactor เปิดให้เล่นวันที่ 12 สิงหาคม 2026 เวลา 18:00–23:59 น. เท่านั้น",
          showReward: false,
          canRetry: false,
          retryLabel: ""
        },
        "member-error": {
          variant: "error",
          title: "ตรวจสอบสมาชิกไม่ได้",
          message:
            this.detailMessage ||
            "ไม่พบบัญชี UFAEASY888 ที่ผูกกับ LINE นี้ กรุณาติดต่อแอดมิน",
          showReward: false,
          canRetry: false,
          retryLabel: ""
        },
        "session-error": {
          variant: "error",
          title: "กรุณาเปิดลิงก์ใหม่",
          message:
            this.detailMessage ||
            "LIFF session หมดอายุ กรุณาปิดหน้านี้แล้วเปิดลิงก์จาก LINE อีกครั้ง",
          showReward: false,
          canRetry: true,
          retryLabel: "ลองเชื่อมต่ออีกครั้ง"
        },
        "submit-error": {
          variant: "error",
          title: "ยังบันทึกผลไม่สำเร็จ",
          message:
            this.detailMessage ||
            "การเชื่อมต่อขัดข้อง กดส่งผลอีกครั้งได้โดยไม่เล่นใหม่",
          showReward: false,
          canRetry: true,
          retryLabel: "ส่งผลอีกครั้ง"
        },
        error: {
          variant: "error",
          title: "เกิดข้อผิดพลาด",
          message: this.detailMessage || "กรุณาลองเชื่อมต่อใหม่อีกครั้ง",
          showReward: false,
          canRetry: true,
          retryLabel: "ลองอีกครั้ง"
        }
      };
      return copies[this.state] || copies.error;
    }
  },
  mounted() {
    document.body.classList.add("tap-coin-body");
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.loadStatus();
  },
  beforeDestroy() {
    this.destroyed = true;
    document.body.classList.remove("tap-coin-body");
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    this.clearAllTimers();
  },
  methods: {
    async loadStatus() {
      this.state = "loading";
      this.detailMessage = "";
      this.accessToken = liffService.getAccessToken() || "";
      if (!this.accessToken) {
        this.state = "session-error";
        return;
      }

      try {
        const status = await getTapCoinStatus(this.accessToken);
        if (this.destroyed) return;
        this.balance = Number(status.balance || 0);
        this.totalDeposit = Number(status.totalDeposit || 0);
        this.minDeposit = Number(status.minDeposit || 350);
        this.reward = Number(status.reward || 0);
        this.durationMs = Number(status.durationMs || DEFAULT_DURATION_MS);
        this.remainingMs = this.durationMs;

        if (status.playStatus === "completed") {
          this.state = "result";
        } else if (
          status.playStatus === "started" ||
          status.playStatus === "forfeited"
        ) {
          this.state = "already-used";
        } else if (status.eventStatus === "upcoming") {
          this.state = "event-upcoming";
        } else if (status.eventStatus === "closed") {
          this.state = "event-closed";
        } else if (!status.depositEligible) {
          this.state = "deposit-insufficient";
        } else {
          this.state = "ready";
        }
      } catch (error) {
        if (!this.destroyed) this.handleStatusError(error);
      }
    },

    async startGame() {
      if (this.state !== "ready") return;
      this.tapCount = 0;
      this.tapOffsetsMs = [];
      this.submittedOffsetsMs = [];
      this.roundEnding = false;
      this.roundToken = "";
      this.roundReady = false;
      this.countdownFinished = false;
      this.startCountdown(DEFAULT_COUNTDOWN_MS);

      try {
        const round = await startTapCoinRound(this.accessToken);
        if (this.destroyed) return;
        this.roundToken = round.roundToken;
        this.durationMs = Number(round.durationMs || DEFAULT_DURATION_MS);
        this.remainingMs = this.durationMs;
        this.roundReady = true;
        if (this.countdownFinished) this.beginPlay();
      } catch (error) {
        if (!this.destroyed) {
          this.clearAllTimers();
          this.countdown = 0;
          this.roundReady = false;
          this.handleStartError(error);
        }
      }
    },

    startCountdown(durationMs) {
      this.clearAllTimers();
      this.state = "countdown";
      this.countdownDurationMs = Math.max(0, durationMs);
      this.countdownStartedAt = performance.now();
      this.countdown = Math.max(1, Math.ceil(this.countdownDurationMs / 1000));
      this.countdownTimer = window.setInterval(this.tickCountdown, 80);
      this.countdownEndTimer = window.setTimeout(
        this.beginPlay,
        this.countdownDurationMs
      );
    },

    tickCountdown() {
      const elapsed = performance.now() - this.countdownStartedAt;
      const remaining = Math.max(0, this.countdownDurationMs - elapsed);
      this.countdown =
        remaining > 0 ? Math.max(1, Math.ceil(remaining / 1000)) : 0;
      if (remaining <= 0) this.beginPlay();
    },

    beginPlay() {
      if (this.state !== "countdown") return;
      this.clearCountdownTimers();
      if (!this.roundReady) {
        this.countdownFinished = true;
        this.countdown = 0;
        return;
      }
      this.state = "playing";
      this.countdownFinished = true;
      this.countdown = 0;
      this.playStartedAt = performance.now();
      this.remainingMs = this.durationMs;
      this.gameTimer = window.setInterval(this.tickGame, 50);
      this.gameEndTimer = window.setTimeout(this.endRound, this.durationMs);
    },

    tickGame() {
      if (this.state !== "playing") return;
      const elapsed = performance.now() - this.playStartedAt;
      this.remainingMs = Math.max(0, this.durationMs - elapsed);
      if (this.remainingMs <= 0) this.endRound();
    },

    handleTap() {
      if (this.state !== "playing") return;
      const elapsed = Math.floor(performance.now() - this.playStartedAt);
      if (elapsed < 0 || elapsed > this.durationMs) return;
      const previous = this.tapOffsetsMs.length
        ? this.tapOffsetsMs[this.tapOffsetsMs.length - 1]
        : -1;
      if (elapsed <= previous) return;
      this.tapOffsetsMs.push(elapsed);
      this.tapCount = this.tapOffsetsMs.length;
    },

    endRound() {
      if (this.state !== "playing" || this.roundEnding) return;
      this.roundEnding = true;
      this.clearGameTimers();
      this.remainingMs = 0;
      this.submittedOffsetsMs = this.tapOffsetsMs.slice();
      this.submitRound();
    },

    async submitRound() {
      this.state = "submitting";
      this.detailMessage = "";
      let lastError = null;

      for (let attempt = 1; attempt <= 3; attempt += 1) {
        try {
          const result = await finishTapCoinRound(
            this.accessToken,
            this.roundToken,
            this.submittedOffsetsMs
          );
          if (this.destroyed) return;
          this.reward = Number(result.reward || 0);
          this.tapCount = Number(result.tapCount || result.reward || 0);
          this.balance = Number(result.balance || 0);
          this.state = "result";
          return;
        } catch (error) {
          lastError = error;
          if (!this.isRetryableError(error) || attempt === 3) break;
          await this.wait(500 * attempt);
          if (this.destroyed) return;
        }
      }

      if (!this.destroyed) this.handleFinishError(lastError);
    },

    retryAction() {
      if (this.state === "submit-error") {
        this.submitRound();
      } else {
        this.loadStatus();
      }
    },

    handleVisibilityChange() {
      if (document.hidden) return;
      if (this.state === "countdown") this.tickCountdown();
      if (this.state === "playing") this.tickGame();
    },

    handleStatusError(error) {
      const code = this.errorCode(error);
      if (code === "not-found") {
        this.state = "member-error";
      } else if (code === "failed-precondition") {
        this.detailMessage =
          "พบหลายบัญชี UFAEASY888 ที่ใช้ LINE เดียวกัน กรุณาติดต่อแอดมิน";
        this.state = "member-error";
      } else if (code === "unauthenticated" || code === "permission-denied") {
        this.state = "session-error";
      } else {
        this.state = "error";
      }
    },

    handleStartError(error) {
      const code = this.errorCode(error);
      if (code === "already-exists") {
        this.state = "already-used";
      } else if (
        code === "failed-precondition" &&
        this.errorReason(error) === "deposit-insufficient"
      ) {
        const details = error && error.details ? error.details : {};
        this.totalDeposit = Number(details.totalDeposit || 0);
        this.minDeposit = Number(details.minDeposit || 350);
        this.state = "deposit-insufficient";
      } else if (code === "failed-precondition") {
        this.state = "event-closed";
      } else if (code === "unauthenticated" || code === "permission-denied") {
        this.state = "session-error";
      } else {
        this.state = "error";
      }
    },

    handleFinishError(error) {
      const code = this.errorCode(error);
      if (code === "deadline-exceeded" || code === "already-exists") {
        this.detailMessage =
          "รอบนี้หมดเวลาส่งผลหรือถูกใช้ไปแล้ว จึงไม่สามารถเริ่มเล่นใหม่ได้";
        this.state = "already-used";
      } else if (code === "invalid-argument") {
        this.detailMessage =
          "ระบบตรวจพบข้อมูล tap ผิดปกติ รอบนี้จึงไม่สามารถรับเหรียญได้";
        this.state = "already-used";
      } else if (code === "unauthenticated" || code === "permission-denied") {
        this.state = "session-error";
      } else {
        this.detailMessage =
          "การเชื่อมต่อขัดข้อง กดส่งผลอีกครั้งได้โดยไม่ต้องเล่นใหม่";
        this.state = "submit-error";
      }
    },

    errorCode(error) {
      const rawCode = error && error.code ? String(error.code) : "";
      return rawCode.includes("/") ? rawCode.split("/").pop() : rawCode;
    },

    errorReason(error) {
      return error && error.details && error.details.reason
        ? String(error.details.reason)
        : "";
    },

    isRetryableError(error) {
      const code = this.errorCode(error);
      return (
        !code ||
        [
          "aborted",
          "cancelled",
          "internal",
          "resource-exhausted",
          "unavailable",
          "unknown"
        ].includes(code)
      );
    },

    wait(delayMs) {
      return new Promise(resolve => window.setTimeout(resolve, delayMs));
    },

    clearCountdownTimers() {
      if (this.countdownTimer) window.clearInterval(this.countdownTimer);
      if (this.countdownEndTimer) window.clearTimeout(this.countdownEndTimer);
      this.countdownTimer = null;
      this.countdownEndTimer = null;
    },

    clearGameTimers() {
      if (this.gameTimer) window.clearInterval(this.gameTimer);
      if (this.gameEndTimer) window.clearTimeout(this.gameEndTimer);
      this.gameTimer = null;
      this.gameEndTimer = null;
    },

    clearAllTimers() {
      this.clearCountdownTimers();
      this.clearGameTimers();
    },

    closeGame() {
      if (liffService.isInClient) {
        liffService.closeWindow();
      } else {
        this.$router.replace("/");
      }
    }
  }
};
</script>

<template>
  <div class="tap-coin-page">
    <div class="page-aurora page-aurora--one" aria-hidden="true"></div>
    <div class="page-aurora page-aurora--two" aria-hidden="true"></div>
    <div class="page-stars" aria-hidden="true"></div>

    <header class="tap-header">
      <img
        class="tap-header__logo"
        src="../assets/images/logo2.png"
        alt="UFA Easy888"
      />
      <div class="tap-header__member">
        <div class="tap-header__balance">
          <img src="../assets/images/coin.png" alt="" />
          <span>{{ formattedBalance }}</span>
        </div>
        <div
          class="tap-header__avatar"
          :style="avatarStyle"
          aria-hidden="true"
        ></div>
      </div>
    </header>

    <main class="tap-content">
      <div v-if="state === 'loading'" class="loading-card" aria-live="polite">
        <span class="loading-card__spinner"></span>
        <strong>กำลังตรวจสอบสิทธิ์</strong>
        <small>กรุณารอสักครู่</small>
      </div>

      <template v-else-if="showGamePanel">
        <section class="tap-intro">
          <span class="tap-intro__event">12 AUG 2026 • 18:00–23:59</span>
          <h1 class="tap-intro__title">TAP COIN <em>REACTOR</em></h1>
          <p class="tap-intro__welcome">
            {{ displayName }} พร้อมรับเหรียญหรือยัง?
          </p>
        </section>

        <TapCoinReactor
          :active="reactorActive"
          :tap-count="tapCount"
          :remaining-ms="remainingMs"
          :duration-ms="durationMs"
          :countdown="countdown"
          :submitting="isSubmitting"
          :waiting-for-round="isWaitingForRound"
          @tap="handleTap"
        />

        <button
          v-if="state === 'ready'"
          type="button"
          class="start-button"
          @click="startGame"
        >
          <span>เริ่มเกม</span>
          <small>10 วินาที • 1 TAP = 0.5 เหรียญ • ปัดขึ้นตอนจบ</small>
        </button>
        <p v-else class="game-status" aria-live="polite">
          {{ gameStatusText }}
        </p>

        <p class="one-chance-note">
          ฝากช่วง 18:00–23:59 รวมขั้นต่ำ 350 บาท • กดเริ่มแล้ว Refresh ไม่ได้
        </p>
      </template>

      <TapCoinResult
        v-else
        :variant="terminalCopy.variant"
        :title="terminalCopy.title"
        :message="terminalCopy.message"
        :reward="reward"
        :balance="balance"
        :show-reward="terminalCopy.showReward"
        :can-retry="terminalCopy.canRetry"
        :retry-label="terminalCopy.retryLabel"
        @retry="retryAction"
        @close="closeGame"
      />
    </main>

    <footer class="tap-footer">UFAEASY888 • TAP COIN REACTOR</footer>
  </div>
</template>

<style>
body.tap-coin-body {
  min-height: 100vh;
  padding: 0 !important;
  margin: 0;
  background: #08051c !important;
  overscroll-behavior: none;
}
</style>

<style scoped>
.tap-coin-page {
  position: relative;
  display: flex;
  min-height: 100vh;
  overflow: hidden;
  color: #fff;
  flex-direction: column;
  background: radial-gradient(
      circle at 50% 18%,
      rgba(93, 46, 164, 0.3),
      transparent 38%
    ),
    linear-gradient(180deg, #13092d 0%, #08051c 60%, #050313 100%);
  font-family: Kanit, "Sukhumvit Set", -apple-system, BlinkMacSystemFont,
    "Segoe UI", sans-serif;
}

.tap-coin-page *,
.tap-coin-page *::before,
.tap-coin-page *::after {
  box-sizing: border-box;
}

.page-aurora {
  position: fixed;
  width: 420px;
  height: 420px;
  pointer-events: none;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.22;
}

.page-aurora--one {
  top: -240px;
  left: -180px;
  background: #9658ff;
}
.page-aurora--two {
  right: -240px;
  bottom: -180px;
  background: #ff8d31;
}
.page-stars {
  position: fixed;
  inset: 0;
  pointer-events: none;
  opacity: 0.34;
  background-image: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.75) 0 1px,
    transparent 1.5px
  );
  background-size: 39px 39px;
  mask-image: linear-gradient(to bottom, #000, transparent 72%);
}

.tap-header {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(100%, 560px);
  min-height: 78px;
  margin: 0 auto;
  padding: max(10px, env(safe-area-inset-top)) 18px 8px;
}

.tap-header__logo {
  width: 88px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.32));
}
.tap-header__member {
  display: flex;
  align-items: center;
  gap: 9px;
}
.tap-header__balance {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 38px;
  padding: 7px 13px;
  color: #ffd369;
  border: 1px solid rgba(255, 193, 75, 0.25);
  border-radius: 999px;
  background: rgba(24, 11, 47, 0.78);
  backdrop-filter: blur(10px);
}
.tap-header__balance img {
  width: 21px;
  height: 21px;
  object-fit: contain;
}
.tap-header__balance span {
  font-size: 15px;
  font-weight: 900;
}
.tap-header__avatar {
  width: 38px;
  height: 38px;
  border: 2px solid rgba(255, 210, 107, 0.72);
  border-radius: 50%;
  background: linear-gradient(135deg, #8f57dd, #3d245e);
  background-position: center;
  background-size: cover;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.3);
}

.tap-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  width: min(100% - 24px, 560px);
  margin: 0 auto;
  padding: 10px 0 28px;
  flex: 1;
  flex-direction: column;
  justify-content: center;
}

.tap-intro {
  margin: 0 0 15px;
  text-align: center;
}
.tap-intro__event {
  display: inline-block;
  color: #d7a8ff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.15em;
}
.tap-intro__title {
  margin: 5px 0 0;
  color: #fff6d3;
  font-size: clamp(27px, 8vw, 39px);
  line-height: 1;
  font-weight: 1000;
  letter-spacing: -0.04em;
  text-shadow: 0 0 30px rgba(255, 188, 69, 0.2);
}
.tap-intro__title em {
  color: #ffad3d;
  font-style: normal;
}
.tap-intro__welcome {
  margin: 8px 0 0;
  color: #aaa2b9;
  font-size: 13px;
}

.start-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 392px);
  min-height: 60px;
  margin-top: 16px;
  padding: 9px 24px;
  color: #210c30;
  border: 0;
  border-radius: 999px;
  flex-direction: column;
  background: linear-gradient(135deg, #ffe176, #ff9b35 62%, #ff6a46);
  box-shadow: 0 14px 36px rgba(255, 139, 39, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

.start-button span {
  font-size: 20px;
  line-height: 1.1;
  font-weight: 1000;
}
.start-button small {
  margin-top: 3px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  opacity: 0.68;
}
.start-button:active {
  transform: translateY(1px) scale(0.99);
}
.game-status {
  min-height: 25px;
  margin: 17px 0 0;
  color: #f0dfff;
  font-size: 13px;
  text-align: center;
}
.one-chance-note {
  margin: 9px 0 0;
  color: #6f687d;
  font-size: 10px;
  text-align: center;
}

.loading-card {
  display: flex;
  align-items: center;
  width: min(100%, 360px);
  padding: 34px 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 26px;
  flex-direction: column;
  background: rgba(20, 11, 43, 0.86);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.42);
}

.loading-card__spinner {
  width: 52px;
  height: 52px;
  margin-bottom: 17px;
  border: 4px solid rgba(255, 255, 255, 0.12);
  border-top-color: #ffc657;
  border-radius: 50%;
  animation: loadingSpin 0.8s linear infinite;
}
.loading-card strong {
  color: #fff3c3;
  font-size: 18px;
}
.loading-card small {
  margin-top: 6px;
  color: #8c849c;
}
.tap-footer {
  position: relative;
  z-index: 2;
  padding: 7px 12px max(12px, env(safe-area-inset-bottom));
  color: #50495f;
  font-size: 9px;
  text-align: center;
  letter-spacing: 0.2em;
}

@keyframes loadingSpin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-height: 720px) {
  .tap-header {
    min-height: 60px;
  }
  .tap-header__logo {
    width: 72px;
  }
  .tap-content {
    justify-content: flex-start;
    padding-top: 2px;
  }
  .tap-intro {
    margin-bottom: 9px;
  }
  .one-chance-note {
    margin-top: 5px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading-card__spinner {
    animation-duration: 1.5s;
  }
}
</style>
